var _toFlexAlignItems, _toFlexJustifyContent;

import React from 'react';
import * as _ from "../../../util/lodash";
import { createComponent, PropTypes } from "../../../wayin-react";
import { sizes, colors, positions } from "../../../enums";
import cx from 'classnames';
import Modal from "../../core/modal"; //transforms some of the horizontal positions to flex alignItems props

var toFlexAlignItems = (_toFlexAlignItems = {}, _toFlexAlignItems[positions.LEFT] = 'flex-start', _toFlexAlignItems[positions.CENTER] = 'center', _toFlexAlignItems[positions.RIGHT] = 'flex-end', _toFlexAlignItems); //transforms some of the vertical positions to flex justifyContent props

var toFlexJustifyContent = (_toFlexJustifyContent = {}, _toFlexJustifyContent[positions.verticalAlign.TOP] = 'flex-start', _toFlexJustifyContent[positions.verticalAlign.MIDDLE] = 'center', _toFlexJustifyContent[positions.verticalAlign.BOTTOM] = 'flex-end', _toFlexJustifyContent);
/**
 * base component for creating a panel container, with ability to set size, header horizontal and vertical align and background bgColor
 * it creates the header and content structure for a vertical panel
 */

var PanelContainer = createComponent({
  displayName: 'PanelContainer',
  propTypes: {
    bgColor: PropTypes.oneOf([colors.GREY, colors.DARK, colors.DARKER, colors.WHITE]),
    header: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    headerAlign: PropTypes.shape({
      horizontal: PropTypes.oneOf([positions.LEFT, positions.CENTER, positions.RIGHT]),
      vertical: PropTypes.oneOf([positions.verticalAlign.TOP, positions.verticalAlign.MIDDLE, positions.verticalAlign.BOTTOM])
    }),
    size: PropTypes.oneOf([sizes.X1, sizes.SMALL, sizes.MEDIUM, sizes.LARGE, sizes.X8]),
    style: PropTypes.object,
    className: PropTypes.string
  },
  defaultProps: {
    bgColor: colors.DARK,
    header: [],
    children: [],
    headerAlign: {
      horizontal: positions.CENTER,
      vertical: positions.verticalAlign.MIDDLE
    },
    size: sizes.MEDIUM,
    style: {},
    className: ''
  },
  render: function render(props) {
    var bgColor = props.bgColor,
        header = props.header,
        children = props.children,
        headerAlign = props.headerAlign,
        size = props.size,
        style = props.style,
        className = props.className;
    var headerStyles = {
      alignItems: toFlexAlignItems[headerAlign.horizontal],
      justifyContent: toFlexJustifyContent[headerAlign.vertical]
    };
    return /*#__PURE__*/React.createElement("div", {
      className: cx('modal-app-panel', className, "bg-color-" + bgColor, "size-" + size),
      style: style
    }, /*#__PURE__*/React.createElement("div", {
      className: "modal-app-panel__header-container",
      style: headerStyles
    }, header), /*#__PURE__*/React.createElement("div", {
      className: "modal-app-panel__content-container"
    }, children));
  }
});
/**
 * reuses PanelContainer, sets up the container to show up as a side bar panel component
 * uses the smallest width available
 */

var SideNav = createComponent({
  displayName: 'SideNav',
  propTypes: {
    header: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
  },
  defaultProps: {
    header: [],
    children: []
  },
  render: function render(props) {
    var header = props.header,
        children = props.children;
    return header || children ? /*#__PURE__*/React.createElement(PanelContainer, {
      className: "modal-app-panel--side-nav",
      header: header,
      bgColor: colors.DARKER,
      headerAlign: {
        horizontal: positions.CENTER,
        vertical: positions.verticalAlign.MIDDLE
      },
      size: sizes.X1
    }, children) : null;
  }
});
/**
 * reuses PanelContainer, sets up the container to show up as a wider panel component
 * takes up a Medium size width
 */

var LeftPanel = createComponent({
  displayName: 'LeftPanel',
  propTypes: {
    size: PropTypes.oneOf([sizes.SMALL, sizes.MEDIUM, sizes.LARGE]),
    header: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
  },
  defaultProps: {
    size: sizes.MEDIUM,
    header: [],
    children: []
  },
  render: function render(props) {
    var header = props.header,
        children = props.children,
        size = props.size;
    return !_.isEmpty(header) || !_.isEmpty(children) ? /*#__PURE__*/React.createElement(PanelContainer, {
      className: "modal-app-panel--left-panel",
      header: header,
      bgColor: colors.DARK,
      headerAlign: {
        horizontal: positions.LEFT,
        vertical: positions.verticalAlign.BOTTOM
      },
      size: size
    }, children) : null;
  }
});
/**
 * reuses PanelContainer, sets up the container to show up as a side bar panel component
 * takes up all remaining width
 */

var RightPanel = createComponent({
  displayName: 'RightPanel',
  propTypes: {
    header: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
  },
  defaultProps: {
    header: [],
    children: []
  },
  render: function render(props) {
    var header = props.header,
        children = props.children;
    return !_.isEmpty() || !_.isEmpty(children) ? /*#__PURE__*/React.createElement(PanelContainer, {
      className: "modal-app-panel--right-panel",
      header: header,
      bgColor: colors.GREY,
      headerAlign: {
        horizontal: positions.RIGHT,
        vertical: positions.verticalAlign.MIDDLE
      },
      size: sizes.X8
    }, children) : null;
  }
});
/**
 * Modal Application component
 * wraps children into divs and css to output a modal applicaton layout, containing siderbar, sidepanel and content
 * accepts SideNav, LeftPanel, RightPanel components as children
 */

var ModalApplication = createComponent({
  displayName: 'ModalApplication',
  propTypes: {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    appClassName: PropTypes.string,
    isVisible: PropTypes.bool
  },
  defaultProps: {
    appClassName: '',
    isVisible: false
  },
  render: function render(props) {
    var isVisible = props.isVisible,
        appClassName = props.appClassName;
    return /*#__PURE__*/React.createElement(Modal, {
      isFullscreen: true,
      isSolid: true,
      showModal: isVisible,
      hasCloseIcon: false
    }, /*#__PURE__*/React.createElement("div", {
      className: cx('ck', 'modal-application', appClassName)
    }, props.children));
  }
});
ModalApplication.PanelContainer = PanelContainer;
ModalApplication.SideNav = SideNav;
ModalApplication.LeftPanel = LeftPanel;
ModalApplication.RightPanel = RightPanel;
export { ModalApplication, SideNav, LeftPanel, RightPanel };
export default ModalApplication;
//# sourceMappingURL=index.js.map